import { useIntl } from 'react-intl'
import CellContent from './CellContent'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  offer: App.HotelOffer
  packageUniqueKey: string
}

function LEHotelRoomSizeCell({ offer, packageUniqueKey }: Props) {
  const intl = useIntl()
  const pkg = offer.packages.find(p => p.uniqueKey === packageUniqueKey)

  return (
    <CellContent>
      {pkg && <BodyText variant="medium">{intl.formatMessage(
        {
          id: 'KHA73J93cW7TpF5c7i-P',
          defaultMessage: '{sizeSqm} m\u00B2',
          description: 'Room size display with square meter unit in offer comparison',
        },
        { sizeSqm: pkg.roomType.sizeSqm },
      )}
      </BodyText>}
    </CellContent>
  )
}

export default LEHotelRoomSizeCell
